import { useAppContext } from '../../../../../app/Context';

const useHeader = () => {
  const { isPresenting } = useAppContext();

  return { isPresenting };
};

export default useHeader;
